<script setup lang="ts">
import { useTheme } from 'vuetify'

import { useSSE } from '@/composables/useSSE'
import { useToast } from '@/stores/toastStore'
import ScrollToTop from '@core/components/ScrollToTop.vue'
import initCore from '@core/initCore'
import { initConfigStore, useConfigStore } from '@core/stores/config'
import { hexToRgb } from '@layouts/utils'

useSSE()

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()

const useToastStore = useToast()

const { showSnackbar, responseCode, responseMessage, toastTimeout, toastLink, toastTimer, toastLinkText }
  = storeToRefs(useToastStore)
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />

      <SnackbarResponseAPI
        v-model="showSnackbar"
        :message="responseMessage"
        :code="responseCode"
        :timeout="toastTimeout"
        :link="toastLink"
        :timer="toastTimer"
        :link-text="toastLinkText"
      />

      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
